/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Policy_Sharing_LabelInputs */



/**
* | output |
* | --- |
* | "Who may share agents" |
*
* @param {Agent_Policy_Sharing_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_sharing_label = /** @type {((inputs?: Agent_Policy_Sharing_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Sharing_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wer Agenten teilen darf")
	return /** @type {LocalizedString} */ ("Who may share agents")
});